module.exports = __webpack_public_path__ + "img/ring_r_x_o_null.c6b01511.png";